<form (ngSubmit)="onSubmit()" [formGroup]="customerSelectionForm">
  <label>
    <input
      aria-required="true"
      #searchTerm
      type="text"
      formControlName="searchTerm"
      placeholder="Customer Name/Email Address"
    />
    <cx-form-errors
      aria-live="assertive"
      aria-atomic="true"
      [control]="customerSelectionForm.get('searchTerm')"
    ></cx-form-errors>
  </label>
  <button type="submit">Start Session</button>
</form>

@if (searchResults | async; as results) {
  <div class="asm-results" #resultList>
    @for (result of results.entries; track result.uid) {
      <button (click)="selectCustomerFromList(result)">
        <span class="result-name">{{ result.name }}</span>
        <span class="result-id">{{ result.uid }}</span>
        <span class="result-id">{{ result.phone | sdPhoneFormat }}</span>
      </button>
    }
    @if (
      (searchResultsLoading$ | async) === false &&
      searchTerm.value.length >= 3 &&
      !!results.entries &&
      results.entries.length <= 0
    ) {
      <button (click)="closeResults()">No customer found.</button>
    }
  </div>
}

@if (searchResultsLoading$ | async) {
  <div class="asm-results">
    <div class="spinner" aria-hidden="false" [attr.aria-label]="'common.loading'">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
}
